module.exports = __webpack_public_path__ + "static/media/lin.678ea4c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/lin.svg
// module id = ./src/common/images/lin.svg
// module chunks = 1